<template>
    <div class="investors-wrapper">
      <app-header></app-header>
      <div class="investors-content">
        <app-aside :linksArray="links"></app-aside>
        <div class="investors-content-main">
          <app-management v-if="this.$route.params.page == 'management'"></app-management>
          <app-financial-statements v-if="this.$route.params.page == 'financial-statements'"></app-financial-statements>
          <app-general-meetings v-if="this.$route.params.page == 'general-meetings'"></app-general-meetings>
          <app-calendar v-if="this.$route.params.page == 'calendar'"></app-calendar>
          <app-shares v-if="this.$route.params.page == 'shares'"></app-shares>
          <app-information v-if="this.$route.params.page == 'information'"></app-information>
          <!-- <app-presentations v-if="this.$route.params.page == 'presentations'"></app-presentations> -->
        </div>
      </div>
    </div>
</template>

<script>
import Header from "./investors/Header";
import Aside from "./shared/Aside";
import Management from "./investors/Management";
import FinancialStatements from "./investors/FinancialStatements";
import GeneralMeetings from "./investors/GeneralMeetings";
import Calendar from "./investors/Calendar";
import Information from "./investors/Information";
import Shares from "./investors/Shares";
//import Presentations from "./investors/Presentations";
export default {
  components: {
    appHeader: Header,
    appAside: Aside,
    appManagement: Management,
    appFinancialStatements: FinancialStatements,
    appGeneralMeetings: GeneralMeetings,
    appCalendar: Calendar,
    appInformation: Information,
    appShares: Shares
    //appPresentations: Presentations
  },
  data() {
    return {
      links: [
        { name: "Корпоративно управление", url: "/investors/management" },
        { name: "Финансови отчети", url: "/investors/financial-statements" },
        { name: "Общи събрания", url: "/investors/general-meetings" },
        { name: "Календар за инвеститорите", url: "/investors/calendar" },
        { name: "Акции", url: "/investors/shares" },
        { name: "Вътрешна информация", url: "/investors/information" }
        //{ name: "Презентации", url: "/investors/presentations" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      //      this.isPageExisting();
    }
  },
  methods: {
    isPageExisting() {
      switch (this.$route.params.page) {
        case "management":
          break;
        default:
          this.$router.replace("../404");
      }
    }
  },
  mounted() {
    //    this.isPageExisting();
  }
};
</script>

<style scoped>
.investors-content {
  display: flex;
}
.investors-content-main {
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .investors-content-main {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Investors.vue